import { formatDate } from "../../../api/DateUtils";
import { Column } from "react-table";
import { Grid } from "../../../leap-components/Grid";
import EpaCard from "../../../leap-components/EpaCard";
import { Link } from "react-router-dom";
import {
  GetFilteredLicenceDocumentsFetchUrl,
  IDocumentsColumnFilterList,
} from "../../../api/Documents";
import { CreateStaticSelectColumnFilter } from "../../../leap-components/Grid/FetchGrid/StaticSelectColumnFilter";

interface ISearchResultRow {
  document_id: string;
  notifier_id: string;
  document_name: string;
  created_by: string;
  date: string;
  document_url: string;
  classification: string;
  category: string;
}

interface DocumentsGridProps {
  licenceId: string;
  createdByFilter: IDocumentsColumnFilterList;
  classificationFilter: IDocumentsColumnFilterList;
  subclassificationFilter: IDocumentsColumnFilterList;
}

const DocumentsGrid = ({
  licenceId,
  createdByFilter,
  classificationFilter,
  subclassificationFilter,
}: DocumentsGridProps) => {
  const getFetchUrlFactory = (licenceId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetFilteredLicenceDocumentsFetchUrl(
        licenceId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(licenceId);

  const tableColumnsBig: Column<Record<string, ISearchResultRow>>[] = [
    {
      Header: "Date",
      accessor: "documentdate",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Created By",
      accessor: "createdby",
      Filter: CreateStaticSelectColumnFilter(
        createdByFilter.list.map((filterValue) => filterValue.value)
      ),
      filter: "includes",
    },
    {
      Header: "Category",
      accessor: "classification",
      Filter: CreateStaticSelectColumnFilter(
        classificationFilter.list.map((filterValue) => filterValue.value)
      ),
      filter: "includes",
    },
    {
      Header: "Subcategory",
      accessor: "subclassification",
      Filter: CreateStaticSelectColumnFilter(
        subclassificationFilter.list.map((filterValue) => filterValue.value)
      ),
      filter: "includes",
    },
    {
      Header: "Document Name",
      accessor: "filename",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return <a href={rowData.url}>{rowInfo.value}</a>;
      },
      sortType: "basic",
    },
  ];

  const tableColumnsSmall: Column<Record<string, ISearchResultRow>>[] = [
    {
      Header: "Date",
      accessor: "documentdate",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Created By",
      accessor: "createdby",
      Filter: CreateStaticSelectColumnFilter(
        createdByFilter.list.map((filterValue) => filterValue.value)
      ),
      filter: "includes",
    },
    {
      Header: "Category",
      accessor: "classification",
      Filter: CreateStaticSelectColumnFilter(
        classificationFilter.list.map((filterValue) => filterValue.value)
      ),
      filter: "includes",
    },
    {
      Header: "Subcategory",
      accessor: "subclassification",
      Filter: CreateStaticSelectColumnFilter(
        subclassificationFilter.list.map((filterValue) => filterValue.value)
      ),
      filter: "includes",
    },
    {
      Header: "Document Name",
      accessor: "filename",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return <a href={rowData.url}>{rowInfo.value}</a>;
      },
      sortType: "basic",
    },
  ];

  var bodyElements = (
    <div className="ps-0">
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return <EpaCard title={"Documents"} content={bodyElements} />;
};

export { DocumentsGrid };
